export const OrdersData = [
  {
    id: "1",
    image:"assets/img/users/user-30.jpg",
    Order_ID: "5655898",
    Customer: "James Kirwin",
    Payment_Type: "PayPal",
    Amount: "$600",
    Date_Time: "24 Dec 2024, 04:12 PM",
    Status: "Complete",
  },
  {
    id: "2",
    image:"assets/img/users/user-13.jpg",
    Order_ID: "5573158",
    Customer: "Francis Chang",
    Payment_Type: "PayPal",
    Amount: "$160",
    Date_Time: "10 Dec 2024, 10:30 AM",
    Status: "Pending",
  },
  {
    id: "3",
    image:"assets/img/users/user-11.jpg",
    Order_ID: "4837512",
    Customer: "Antonio Engle",
    Payment_Type: "Debit Card",
    Amount: "$110",
    Date_Time: "27 Nov 2024, 03:15 PM",
    Status: "Complete",
  },
  {
    id: "4",
    image:"assets/img/users/user-32.jpg",
    Order_ID: "4628754",
    Customer: "Leo Kelly",
    Payment_Type: "PayPal",
    Amount: "$120",
    Date_Time: "18 Nov 2024, 09:00 AM",
    Status: "Complete",
  },
  {
    id: "5",
    image:"assets/img/users/user-02.jpg",
    Order_ID: "4279685",
    Customer: "Annette Walker",
    Payment_Type: "PayPal",
    Amount: "$80",
    Date_Time: "06 Nov 2024, 10:45 AM",
    Status: "Proccessing",
  },
  {
    id: "6",
    image:"assets/img/users/user-05.jpg",
    Order_ID: "3754250",
    Customer: "John Weaver",
    Payment_Type: "Debit Card",
    Amount: "$320",
    Date_Time: "25 Oct 2024, 06:30 PM",
    Status: "Complete",
  },
  {
    id: "7",
    image:"assets/img/users/user-08.jpg",
    Order_ID: "3459687",
    Customer: "Gary Hennessy",
    Payment_Type: "PayPal",
    Amount: "$60",
    Date_Time: "14 Oct 2024, 02:45 PM",
    Status: "Complete",
  },
  {
    id: "8",
    image:"assets/img/users/user-04.jpg",
    Order_ID: "2186348",
    Customer: "Eleanor Panek",
    Payment_Type: "Credit Card",
    Amount: "$540",
    Date_Time: "14 Oct 2024, 02:45 PM",
    Status: "Pending",
  },
  {
    id: "9",
    image:"assets/img/users/user-09.jpg",
    Order_ID: "3754250",
    Customer: "William Levy",
    Payment_Type: "PayPal",
    Amount: "$200",
    Date_Time: "03 Oct 2024, 11:20 AM",
    Status: "Complete",
  },
  {
    id: "10",
    image:"assets/img/users/user-10.jpg",
    Order_ID: "2973542",
    Customer: "Charlotte Klotz",
    Payment_Type: "Credit Card",
    Amount: "$45",
    Date_Time: "20 Sep 2024, 07:10 PM",
    Status: "Complete",
  },
  {
    id: "11",
    image:"assets/img/users/user-10.jpg",
    Order_ID: "3754250",
    Customer: "Charlotte Klotz",
    Payment_Type: "Debit Card",
    Amount: "$45",
    Date_Time: "14 Oct 2024, 02:45 PM",
    Status: "Complete",
  },
];
